export default __webpack_public_path__ + "static/media/filter_icon_shop_blue.d22625e6.svg";